import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { ThreatLevelManageContent } from "../Component/ThreatLevelManageContent";

const ThreatLevelManage = () => {
  const seoData = getSEOData("/threat-manage");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <ThreatLevelManageContent />
    </>
  );
};

export default ThreatLevelManage;
